import React, { useCallback, useEffect, useState, useRef, lazy } from 'react';
const WIDGET_ORIGIN = 'https://widgets.meatmarket.ai';
const WIDGET_ID = 'usda-market-pulse';
const PUBLISHABLE_TOKEN = 'mmw_live_pub_GRUxBZdMA606iQKMf_Snq4S4WXYgpBVz6l2PoKyfLf0';
const WIDGET_URL = 'https://widgets.meatmarket.ai/embed/market-widget?proteins=beef%2Cpork&layout=sector-board&theme=light&currency=usd&title=usda-market-pulse&auth=post-message&widget=usda-market-pulse';
interface WidgetMessage {
  type?: string;
  widgetId?: string;
  data?: {
    height?: unknown;
  };
}
function isWidgetMessage(value: unknown): value is WidgetMessage {
  return typeof value === 'object' && value !== null;
}
export function SidebarMarketWidget() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const timeoutIdsRef = useRef<number[]>([]);
  const [height, setHeight] = useState(368);
  const sendAuth = useCallback(() => {
    const iframe = iframeRef.current;
    if (!iframe?.isConnected || !iframe.contentWindow) {
      return;
    }
    iframe.contentWindow.postMessage({
      type: 'MEATMARKET_AUTH',
      token: PUBLISHABLE_TOKEN
    }, WIDGET_ORIGIN);
  }, []);
  const sendAuthBurst = useCallback(() => {
    timeoutIdsRef.current.forEach(timeoutId => window.clearTimeout(timeoutId));
    timeoutIdsRef.current = [];
    sendAuth();
    timeoutIdsRef.current = [80, 180, 360, 720, 1400].map(delay => window.setTimeout(sendAuth, delay));
  }, [sendAuth]);
  useEffect(() => {
    sendAuthBurst();
    const handleMessage = (event: MessageEvent<unknown>) => {
      if (event.origin !== WIDGET_ORIGIN || event.source !== iframeRef.current?.contentWindow || !isWidgetMessage(event.data) || event.data.widgetId !== WIDGET_ID) {
        return;
      }
      if (event.data.type === 'MEATMARKET_READY') {
        sendAuth();
      }
      if (event.data.type === 'MEATMARKET_RESIZE') {
        const nextHeight = Number(event.data.data?.height);
        if (Number.isFinite(nextHeight) && nextHeight > 0) {
          setHeight(Math.ceil(nextHeight));
        }
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      timeoutIdsRef.current.forEach(timeoutId => window.clearTimeout(timeoutId));
      window.removeEventListener('message', handleMessage);
    };
  }, [sendAuth, sendAuthBurst]);
  return <section className="mb-8 w-full overflow-hidden" data-id="element-250">
      <iframe ref={iframeRef} src={WIDGET_URL} width="100%" height={height} onLoad={sendAuthBurst} className="block w-full border-0" style={{
      borderRadius: '18px',
      overflow: 'hidden'
    }} loading="lazy" scrolling="no" sandbox="allow-scripts allow-same-origin allow-popups" referrerPolicy="strict-origin-when-cross-origin" title="USDA Market Pulse" data-id="element-251" />
    </section>;
}